/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        SoloQGameSummaries,
        SoloQGameSummariesAggregate,
    } from '../models/index';

            export interface SoloQGameSummariesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                account?: number;
                additional_filters?: object;
                agent?: string;
                aggregates?: Array<string>;
                competitive_player?: string;
                date?: string;
                game_id?: string;
                having?: object;
                ig_name?: string;
                index_on?: string;
                map?: string;
                metrics?: Array<string>;
                patch?: string;
                puuid?: string;
                rank_tier?: SoloQGameSummariesAggregateRankTierEnum;
                server?: string;
                team?: SoloQGameSummariesAggregateTeamEnum;
                win?: boolean;
            }

            export interface SoloQGameSummariesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                account?: number;
                additional_filters?: object;
                agent?: string;
                competitive_player?: string;
                date?: string;
                game_id?: string;
                ig_name?: string;
                map?: string;
                patch?: string;
                puuid?: string;
                rank_tier?: SoloQGameSummariesFieldValuesRankTierEnum;
                server?: string;
                team?: SoloQGameSummariesFieldValuesTeamEnum;
                win?: boolean;
            }

            export interface SoloQGameSummariesGetRequest {
                id: string;
            }

            export interface SoloQGameSummariesListRequest {
                account?: number;
                additional_filters?: object;
                agent?: string;
                annotations?: Array<string>;
                competitive_player?: string;
                date?: string;
                game_id?: string;
                ig_name?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                patch?: string;
                puuid?: string;
                rank_tier?: SoloQGameSummariesListRankTierEnum;
                server?: string;
                team?: SoloQGameSummariesListTeamEnum;
                win?: boolean;
            }

            export interface SoloQGameSummariesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                account?: number;
                additional_filters?: object;
                agent?: string;
                competitive_player?: string;
                date?: string;
                game_id?: string;
                ig_name?: string;
                map?: string;
                patch?: string;
                puuid?: string;
                rank_tier?: SoloQGameSummariesVariableDistributionRankTierEnum;
                server?: string;
                team?: SoloQGameSummariesVariableDistributionTeamEnum;
                win?: boolean;
            }

        /**
        * 
        */
            export class SoloQGameSummariesApi extends runtime.BaseAPI {

            /**
            */
            async soloQGameSummariesAggregateRaw(requestParameters: SoloQGameSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQGameSummariesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling soloQGameSummariesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQGameSummariesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.ig_name !== undefined) {
                            queryParameters['ig_name'] = requestParameters.ig_name;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.server !== undefined) {
                            queryParameters['server'] = requestParameters.server;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQGameSummaries/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: SoloQGameSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQGameSummariesAggregate>> {
                    const response = await this.soloQGameSummariesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQGameSummariesFieldValuesRaw(requestParameters: SoloQGameSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling soloQGameSummariesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling soloQGameSummariesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.ig_name !== undefined) {
                            queryParameters['ig_name'] = requestParameters.ig_name;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.server !== undefined) {
                            queryParameters['server'] = requestParameters.server;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQGameSummaries/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: SoloQGameSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.soloQGameSummariesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQGameSummariesGetRaw(requestParameters: SoloQGameSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoloQGameSummaries>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling soloQGameSummariesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQGameSummaries/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: SoloQGameSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoloQGameSummaries> {
                    const response = await this.soloQGameSummariesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQGameSummariesListRaw(requestParameters: SoloQGameSummariesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SoloQGameSummaries>>> {
            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.ig_name !== undefined) {
                            queryParameters['ig_name'] = requestParameters.ig_name;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.server !== undefined) {
                            queryParameters['server'] = requestParameters.server;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQGameSummaries/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: SoloQGameSummariesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SoloQGameSummaries>> {
                    const response = await this.soloQGameSummariesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async soloQGameSummariesVariableDistributionRaw(requestParameters: SoloQGameSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling soloQGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling soloQGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling soloQGameSummariesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling soloQGameSummariesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.account !== undefined) {
                            queryParameters['account'] = requestParameters.account;
                    }

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.competitive_player !== undefined) {
                            queryParameters['competitive_player'] = requestParameters.competitive_player;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.game_id !== undefined) {
                            queryParameters['game_id'] = requestParameters.game_id;
                    }

                    if (requestParameters.ig_name !== undefined) {
                            queryParameters['ig_name'] = requestParameters.ig_name;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.puuid !== undefined) {
                            queryParameters['puuid'] = requestParameters.puuid;
                    }

                    if (requestParameters.rank_tier !== undefined) {
                            queryParameters['rank_tier'] = requestParameters.rank_tier;
                    }

                    if (requestParameters.server !== undefined) {
                            queryParameters['server'] = requestParameters.server;
                    }

                    if (requestParameters.team !== undefined) {
                            queryParameters['team'] = requestParameters.team;
                    }

                    if (requestParameters.win !== undefined) {
                            queryParameters['win'] = requestParameters.win;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/SoloQGameSummaries/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: SoloQGameSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.soloQGameSummariesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }

                            /**
                            * @export
                            */
                            export const SoloQGameSummariesAggregateRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQGameSummariesAggregateRankTierEnum = typeof SoloQGameSummariesAggregateRankTierEnum[keyof typeof SoloQGameSummariesAggregateRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesAggregateTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQGameSummariesAggregateTeamEnum = typeof SoloQGameSummariesAggregateTeamEnum[keyof typeof SoloQGameSummariesAggregateTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesFieldValuesRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQGameSummariesFieldValuesRankTierEnum = typeof SoloQGameSummariesFieldValuesRankTierEnum[keyof typeof SoloQGameSummariesFieldValuesRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesFieldValuesTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQGameSummariesFieldValuesTeamEnum = typeof SoloQGameSummariesFieldValuesTeamEnum[keyof typeof SoloQGameSummariesFieldValuesTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesListRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQGameSummariesListRankTierEnum = typeof SoloQGameSummariesListRankTierEnum[keyof typeof SoloQGameSummariesListRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesListTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQGameSummariesListTeamEnum = typeof SoloQGameSummariesListTeamEnum[keyof typeof SoloQGameSummariesListTeamEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesVariableDistributionRankTierEnum = {
                                NUMBER_0: 0,
                                NUMBER_1: 1,
                                NUMBER_10: 10,
                                NUMBER_11: 11,
                                NUMBER_12: 12,
                                NUMBER_13: 13,
                                NUMBER_14: 14,
                                NUMBER_15: 15,
                                NUMBER_16: 16,
                                NUMBER_17: 17,
                                NUMBER_18: 18,
                                NUMBER_19: 19,
                                NUMBER_2: 2,
                                NUMBER_20: 20,
                                NUMBER_21: 21,
                                NUMBER_22: 22,
                                NUMBER_23: 23,
                                NUMBER_24: 24,
                                NUMBER_25: 25,
                                NUMBER_26: 26,
                                NUMBER_27: 27,
                                NUMBER_3: 3,
                                NUMBER_4: 4,
                                NUMBER_5: 5,
                                NUMBER_6: 6,
                                NUMBER_7: 7,
                                NUMBER_8: 8,
                                NUMBER_9: 9
                            } as const;
                            export type SoloQGameSummariesVariableDistributionRankTierEnum = typeof SoloQGameSummariesVariableDistributionRankTierEnum[keyof typeof SoloQGameSummariesVariableDistributionRankTierEnum];
                            /**
                            * @export
                            */
                            export const SoloQGameSummariesVariableDistributionTeamEnum = {
                                NUMBER_1: 1,
                                NUMBER_2: 2
                            } as const;
                            export type SoloQGameSummariesVariableDistributionTeamEnum = typeof SoloQGameSummariesVariableDistributionTeamEnum[keyof typeof SoloQGameSummariesVariableDistributionTeamEnum];
